module.exports = __webpack_public_path__ + "static/5-033106ba623ecadee8f78ab97c862598.jpg";